import React from "react";
import { STORAGE_ASSETS } from "../../Const/BaseUrlConst";

type LogoWhiteProps = React.HTMLAttributes<HTMLDivElement> & {};

export const LogoWhite: React.FC<LogoWhiteProps> = ({ ...props }) => {
  return (
    <div {...props}>
      <img src={STORAGE_ASSETS+"/images/svg/logo-white.svg"} alt="" />
    </div>
  );
};